export const joinStrings = (arr, concatterStr = " ,") =>
    arr?.join(concatterStr);

export function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
export function formatEnumString(str) {
    return str
        .toLowerCase() // Convert to lowercase
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
}

export function addWordBreaks(htmlString) {
    return htmlString.replace(/([\/>=])([^\s<>]*)/g, "$1<wbr>$2");
}

/**
 * Beautifies JSON string with proper formatting and indentation
 * @param {string} jsonString - The JSON string to beautify
 * @param {number} indentSpaces - Number of spaces for indentation (default: 2)
 * @returns {string} - Beautified JSON string or original string if invalid JSON
 */
export function beautifyJson(jsonString, indentSpaces = 2) {
    if (!jsonString || typeof jsonString !== 'string') {
        return jsonString;
    }

    try {
        const parsed = JSON.parse(jsonString);
        return JSON.stringify(parsed, null, indentSpaces);
    } catch (err) {
        // Return original string if JSON is invalid
        return jsonString;
    }
}
